import styled from 'styled-components/macro';

export const StatsContainer = styled.div`
  padding: 19px 18px 14px;
  display: flex;
  flex-direction: column;
  min-height: 100%;
  background-color: ${props => props.theme.dark5};
  flex-grow: 1;
`;

export const StatsVenue = styled.div`
  width: 100%;
  height: 70px;
  display: flex;
  color: ${({ theme }) => theme.white};
  font-family: ${props => props.theme.primaryFontLight};

  .bold {
    font-family: ${props => props.theme.primaryFontBold};
    font-size: ${props => props.theme.h5}px;

    @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
      text-align: right;
      font-size: ${props => props.theme.paragraphSmall}px;
    }
  }
  > div {
    width: 35%;
    display: flex;
    flex-direction: column;
    justify-content: center;

    &:first-child {
      justify-content: flex-end;
      align-items: flex-end;

      @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
        p {
          text-align: left;
          &:first-child {
            text-align: left;
          }
        }
      }
    }

    p {
      padding: 0 3px;
      font-family: ${props => props.theme.primaryFontLight};
      &:first-child {
        height: 15px;
        font-size: ${props => props.theme.h5}px;
        margin-bottom: 5px;

        @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
          height: auto;
          line-height: 1;
          text-align: right;
          font-size: ${props => props.theme.paragraph}px;
        }
      }
    }

    &:nth-child(2) {
      width: 40%;
      justify-content: center;
      align-items: center;
      img {
        height: 100%;
        width: auto;
      }
    }
  }
`;

export const StatsTable = styled.div`
  position: sticky;
  top: 0px;

  @media (max-width: ${({ theme }) => `${theme.breakpoints.md}px`}) {
    padding-bottom: 30px;
  }

  table {
    th {
      padding:0;
      div {
        text-transform: uppercase;
        display: block !important;
        text-align: center;
        font-family: ${props => props.theme.primaryFontBold};
        font-size: ${props => props.theme.paragraph}px;
        font-weight: 200;
        color: ${({ theme }) => theme.white};
      }
      &:nth-child(2){
        @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
          opacity: 0;
        }
      }
      }
    }
    tbody {
      tr {
        td {
          padding: 10px 6px;
          text-align: center;
          text-transform: uppercase;
          color: ${({ theme }) => theme.white};
        }
      }
    }
  }
  img {
    width: ${props => props.theme.shieldMedium}px;
  }
`;
